import { WebApi } from "./WebApi";

export default WebApi;
